export default __webpack_public_path__ + "static/media/449.9d0c64ed.png";